import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowIntruder() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.intruder-intervention')}
      description={t('feature-description.intruder-intervention')}
      modalDescription={t('feature-tooltip.intruder-intervention')}
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
